import { render, staticRenderFns } from "./HNLaureano.vue?vue&type=template&id=0bb4f314&scoped=true"
import script from "./HNLaureano.vue?vue&type=script&lang=js"
export * from "./HNLaureano.vue?vue&type=script&lang=js"
import style0 from "./HNLaureano.vue?vue&type=style&index=0&id=0bb4f314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4f314",
  null
  
)

export default component.exports